import JsmMetter from './src/JsmMetter.vue'

JsmMetter.install = (Vue) => {
  Vue.component(JsmMetter.name, JsmMetter)
}

export default JsmMetter
